module.exports = __webpack_public_path__ + "media/images/flags/64/Bolivia-3ba1eac22821cca451cbf7bbe1dc8706.png";